import { ProductGroupFragment } from '@occc/graphql';

const PRODUCT_GROUPS_OK = 'app/ProductGroups/PRODUCT_GROUPS_OK';

type Types = {
  PRODUCT_GROUPS_OK: typeof PRODUCT_GROUPS_OK;
};

const types: Types = {
  PRODUCT_GROUPS_OK,
};

/* Actions */

type ProductGroupsOK = (productGroups: ProductGroupFragment[]) => {
  type: typeof types.PRODUCT_GROUPS_OK;
  productGroups: ProductGroupFragment[];
};

export type Action = ReturnType<ProductGroupsOK>;

export type ActionCreators = {
  ProductGroupsOK: ProductGroupsOK;
};

export type State = Readonly<{
  data: {
    productGroups: ProductGroupFragment[];
  };
}>;

export default types;
